import { MutationTree } from 'vuex';
import { Post, ModuleState, PostStatus } from './types'
import { initialState } from './index'
import Vue from 'vue'

export const mutations: MutationTree<ModuleState> = {
  handleResponse(state, payload: { items: Post[] }) {
    state.posts = payload.items;
  },
  handleResponseFetchBy(state, payload: Post) {
    Vue.set(state, 'post', payload)
  },
  handleFetchPendingByTownResponse(state, payload: Post[]) {
    state.postsByTownPending = payload
  },
  handleResponseByTownByUserPending(state, payload: Post[]) {
    state.postsByTownByUserPending = payload
  },
  handleResponseByTownByUserActive(state, payload: Post[]) {
    state.postsByTownByUserActive = payload
  },
  handleResponseByTownByUserInactive(state, payload: Post[]) {
    state.postsByTownByUserInactive = payload
  },
  handleTownUserByStatusResponse(state, payload: { status: PostStatus; items: Post[] }) {
    state.postsByTownByUserByStatus[payload.status] = payload.items;
  },
  reset(state) { Object.assign(state, initialState) }
};
